"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Permissions = undefined;

var _ice = require("ice");

var _Exceptions = require("../AuthExceptions/Exceptions");

// **********************************************************************
//
// Copyright (c) 2003-2017 ZeroC, Inc. All rights reserved.
//
// This copy of Ice is licensed to you under the terms described in the
// ICE_LICENSE file included in this distribution.
//
// **********************************************************************
//
// Ice version 3.7.0
//
// <auto-generated>
//
// Generated from file `Permissions/Permissions.ice'
//
// Warning: do not edit this file.
//
// </auto-generated>
//

const _ModuleRegistry = _ice.Ice._ModuleRegistry;
const Slice = _ice.Ice.Slice;

let Permissions = _ModuleRegistry.module("Permissions");

const iceC_Permissions_AbstractPermission_ids = ["::Ice::Object", "::Permissions::AbstractPermission"];

/**
 * Base class for all permissions.
 **/
Permissions.AbstractPermission = class extends _ice.Ice.Value {};

Slice.defineValue(Permissions.AbstractPermission, iceC_Permissions_AbstractPermission_ids[1], false);

/**
 * Base class for all permissions.
 **/
Permissions.AbstractPermissionDisp = class extends _ice.Ice.Object {};

Slice.defineOperations(Permissions.AbstractPermissionDisp, undefined, iceC_Permissions_AbstractPermission_ids, 1);

Slice.defineSequence(Permissions, "PermissionSeqHelper", "Ice.ObjectHelper", false, "Permissions.AbstractPermission");

const iceC_Permissions_UnknownPermission_ids = ["::Ice::Object", "::Permissions::AbstractPermission", "::Permissions::UnknownPermission"];

/**
 * Used when no Ice class was found for permission.
 **/
Permissions.UnknownPermission = class extends Permissions.AbstractPermission {
    constructor(typeId = "", parameters = "") {
        super();
        this.typeId = typeId;
        this.parameters = parameters;
    }

    _iceWriteMemberImpl(ostr) {
        ostr.writeString(this.typeId);
        ostr.writeString(this.parameters);
    }

    _iceReadMemberImpl(istr) {
        this.typeId = istr.readString();
        this.parameters = istr.readString();
    }
};

Slice.defineValue(Permissions.UnknownPermission, iceC_Permissions_UnknownPermission_ids[2], false);

/**
 * Used when no Ice class was found for permission.
 **/
Permissions.UnknownPermissionDisp = class extends Permissions.AbstractPermissionDisp {};

Slice.defineOperations(Permissions.UnknownPermissionDisp, undefined, iceC_Permissions_UnknownPermission_ids, 2);

Permissions.PrincipalKind = Slice.defineEnum([['User', 0], ['Group', 1], ['Client', 2]]);

const iceC_Permissions_Principal_ids = ["::Ice::Object", "::Permissions::Principal"];

/**
 * User, group or client with assigned set of permissions.
 **/
Permissions.Principal = class extends _ice.Ice.Value {
    constructor(identity = "", kind = Permissions.PrincipalKind.User, permissions = null) {
        super();
        this.identity = identity;
        this.kind = kind;
        this.permissions = permissions;
    }

    _iceWriteMemberImpl(ostr) {
        ostr.writeString(this.identity);
        Permissions.PrincipalKind._write(ostr, this.kind);
        Permissions.PermissionSeqHelper.write(ostr, this.permissions);
    }

    _iceReadMemberImpl(istr) {
        this.identity = istr.readString();
        this.kind = Permissions.PrincipalKind._read(istr);
        this.permissions = Permissions.PermissionSeqHelper.read(istr);
    }
};

Slice.defineValue(Permissions.Principal, iceC_Permissions_Principal_ids[1], false);

/**
 * User, group or client with assigned set of permissions.
 **/
Permissions.PrincipalDisp = class extends _ice.Ice.Object {};

Slice.defineOperations(Permissions.PrincipalDisp, undefined, iceC_Permissions_Principal_ids, 1);

const iceC_Permissions_PermissionsService_ids = ["::Ice::Object", "::Permissions::PermissionsService"];

Permissions.PermissionsService = class extends _ice.Ice.Object {};

Permissions.PermissionsServicePrx = class extends _ice.Ice.ObjectPrx {};

Slice.defineOperations(Permissions.PermissionsService, Permissions.PermissionsServicePrx, iceC_Permissions_PermissionsService_ids, 1, {
    "getPermissions": [, 2, 2,, ["Permissions.PermissionSeqHelper"], [[7], ["Ice.StringSeqHelper"]],, [_Exceptions.AuthExceptions.InvalidToken],, true],
    "getPermissionsFromContext": [, 2, 2,, ["Permissions.PermissionSeqHelper"], [["Ice.ContextHelper"], ["Ice.StringSeqHelper"]],, [_Exceptions.AuthExceptions.InvalidToken, _Exceptions.AuthExceptions.Unauthorized],, true],
    "getPrincipal": [, 2, 2,, ["Permissions.Principal", true], [[7], ["Ice.StringSeqHelper"]],, [_Exceptions.AuthExceptions.InvalidToken],, true],
    "getPrincipalFromContext": [, 2, 2,, ["Permissions.Principal", true], [["Ice.ContextHelper"], ["Ice.StringSeqHelper"]],, [_Exceptions.AuthExceptions.InvalidToken, _Exceptions.AuthExceptions.Unauthorized],, true]
});
exports.Permissions = Permissions;


//////////////////
// WEBPACK FOOTER
// ./~/@slices/Permissions/Permissions.js
// module id = 168
// module chunks = 0